import React from 'react';

import DateTimeInput from '../../../components/DateTimeInput';

function DateTimeFilter({filter, onChange, validations}) {
  return (
    <>
      <DateTimeInput
        placeholder={filter.operator === 'BETWEEN' ? 'Start Date' : 'Choose a date...'}
        date={filter.values[0] ? new Date(filter.values[0]) : null}
        onChange={time => {
          if (filter.operator === 'BETWEEN') {
            onChange({...filter, values: [time.getTime(), filter.values[1]]});
          }
          else {
            onChange({...filter, values: [time.getTime()]});
          }
        }}
        invalid={validations[0]}
        validationText={validations[0]}
      />
      {filter.operator === 'BETWEEN' && (
        <DateTimeInput
          placeholder="End Date"
          style={{marginTop: '0.5rem'}}
          date={filter.values[1] ? new Date(filter.values[1]) : null}
          onChange={time => onChange({...filter, values: [filter.values[0], time.getTime()]})}
          invalid={validations[1]}
          validationText={validations[1]}
        />
      )}
    </>
  );
}

DateTimeFilter.operators = [
  'BETWEEN',
  'GREATER_THAN',
  'LESS_THAN'
];

DateTimeFilter.validate = filter => {
  const messages = [];
  
  if (filter.operator === 'BETWEEN') {
    if (!filter.values[0]) {
      messages[0] = 'Please choose a start date';
    }

    if (!filter.values[1]) {
      messages[1] = 'Please choose an end date';
    }
  }
  else if(!filter.values[0]) {
    messages.push('Please enter a date');
  }

  return messages;
};

export default DateTimeFilter;